import {CardContent, Divider} from "@mui/material";
import React from "react";


export const ContentEn = () => {
    return (
        <CardContent className="space-y-6 p-6 text-sm leading-relaxed">
            <div className="text-center space-y-1">
                <h1 className="text-xl font-bold">PUBLIC OFFER AGREEMENT</h1>
                <p>on Participation in the Electronic Trading Platform "Электронно торговая площадка"</p>
                <p><strong>Location:</strong> Koshy, Republic of Kazakhstan</p>
                <p><strong>Version:</strong> 15.05.2025</p>
            </div>

            <Divider/>

            <p>
                This document represents a public offer (hereinafter referred to as the
                "Agreement") proposed by Электронно торговая площадка LLP (hereinafter referred to as the
                "Operator"), represented by General Director _ acting
                under the Charter, to any legal entity or individual entrepreneur
                (hereinafter referred to as the "Participant") seeking access to the
                services of the electronic trading platform "Электронно торговая площадка".
            </p>

            <p>
                Acceptance of this offer shall be deemed completed when the Participant
                performs any of the following actions:
                <ul className="list-disc pl-6 mt-2">
                    <li>Completes the registration procedure on the Электронно торговая площадка platform at <a
                        className="text-blue-600 underline" href="https://fincome.kz/"
                        target="_blank" rel="noopener noreferrer">https://fincome.kz/</a> and
                        provides a signed registration form (Appendix 1);
                    </li>
                    <li>Registers on the Электронно торговая площадка platform and makes payment according to the
                        issued invoice (Appendix 2).
                    </li>
                </ul>
            </p>

            <Divider/>
            <h2 className="text-lg font-semibold">1. DEFINITIONS</h2>
            <p>All terms used in this Agreement shall be interpreted in accordance with this
                section or the Glossary published on the official Электронно торговая площадка platform website.</p>

            <h2 className="text-lg font-semibold">2. SUBJECT OF THE AGREEMENT</h2>
            <p>The Operator provides the Participant with access to the functionalities of the
                Электронно торговая площадка electronic trading platform (hereinafter referred to as the "Platform")
                in accordance with the current tariffs (Appendix 3). The Participant agrees to
                comply with the Platform rules (Appendix 2) and the terms of this Agreement.</p>

            <h2 className="text-lg font-semibold">3. RIGHTS AND OBLIGATIONS OF THE PARTIES</h2>
            <h3 className="font-medium">3.1 Obligations of the Operator:</h3>
            <ul className="list-disc pl-6">
                <li>Provide access to the Platform's functionalities;</li>
                <li>Ensure data integrity, confidentiality, and technical support;</li>
                <li>Notify Participants about changes in rules or tariffs at least 5 business
                    days in advance;
                </li>
                <li>Provide documentation, reporting, and support in compliance with current
                    legislation and standards.
                </li>
            </ul>

            <h3 className="font-medium">3.2 Obligations of the Participant:</h3>
            <ul className="list-disc pl-6">
                <li>Provide accurate and up-to-date information;</li>
                <li>Use the Platform solely within legal and permitted purposes;</li>
                <li>Maintain confidentiality, data protection, and fair trading principles;</li>
                <li>Fulfill all financial and regulatory obligations in accordance with the
                    Platform rules.
                </li>
            </ul>

            <h2 className="text-lg font-semibold">4. FINANCIAL TERMS</h2>
            <ul className="list-disc pl-6">
                <li>All tariffs and payment terms are published on the official website.</li>
                <li>Additional fees may be charged for services such as analytics, extended
                    access, etc.
                </li>
                <li>All transactions, invoices, and documents are processed electronically.</li>
                <li>Refunds are processed within 10 business days under the specified terms.
                </li>
            </ul>

            <h2 className="text-lg font-semibold">5. LIABILITY</h2>
            <ul className="list-disc pl-6">
                <li>The Parties are liable under the legislation of the Republic of
                    Kazakhstan.
                </li>
                <li>The Operator is not responsible for damages caused by technical failures on
                    the Participant’s side or non-compliance with Platform requirements.
                </li>
                <li>The Participant is responsible for the confidentiality of login credentials
                    and the accuracy of posted information.
                </li>
            </ul>

            <h2 className="text-lg font-semibold">6. FORCE MAJEURE</h2>
            <p>Force majeure includes natural disasters, armed conflicts, governmental acts, and
                other unforeseen circumstances. The affected party must notify the other party
                within 3 business days.</p>

            <h2 className="text-lg font-semibold">7. CONFIDENTIALITY</h2>
            <p>The Parties agree not to disclose trade secrets, technical information, and
                financial terms. This obligation remains valid for 3 years after the termination
                of the Agreement.</p>

            <h2 className="text-lg font-semibold">8. TERM AND TERMINATION</h2>
            <ul className="list-disc pl-6">
                <li>The Agreement is valid until the end of the current calendar year and is
                    automatically extended unless either party provides notice of termination at
                    least 30 days before expiration.
                </li>
                <li>The Operator may suspend or terminate the Agreement in case of non-payment
                    or violations of its terms.
                </li>
                <li>All changes are published on the website. The Participant may object within
                    5 days. Silence is considered consent.
                </li>
            </ul>

            <h2 className="text-lg font-semibold">9. DISPUTE RESOLUTION</h2>
            <p>All disputes are resolved through a written claim process with a response
                deadline of 15 business days. If unresolved, disputes are subject to court
                proceedings at the Operator’s place of registration.</p>

            <h2 className="text-lg font-semibold">10. APPENDICES</h2>
            <ul className="list-disc pl-6">
                <li>Appendix 1: Registration Form</li>
                <li>Appendix 2: Platform Regulations</li>
                <li>Appendix 3: Tariff Plans</li>
            </ul>

            <p className="italic text-gray-600">
                This Agreement complies with international practices for public offers and
                e-commerce standards, including the UNCITRAL Model Law on Electronic Commerce,
                ISO 20400 (Sustainable Procurement), and General Data Protection Regulation
                (GDPR).
            </p>
        </CardContent>
    )
}
